import React from "react";
import { NavLink } from "react-router-dom";
import { useNavbarContext } from "hooks/useContextAll";

const NavbarLink = (props) => {
    const navbarContext = useNavbarContext();

    return (
        <li className="navbar-item">
            <NavLink
                className="navbar-link header-btn"
                to={props.path}
                onClick={navbarContext.handleNavbarDeactive}
            >
                {props.text}
            </NavLink>
        </li>
    );
};

export default NavbarLink;
